import { Component } from 'react';
import { Typography } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import { getProfile } from '../services/api';
import { connect } from 'react-redux'
import profile from '../redux/profile';
import { withRouter } from 'react-router-dom';

const { Text } = Typography;

class PageNotFound extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    async componentDidMount(){
        // check login by get profile
        // await getProfile()
    }

    // UNSAFE_componentWillReceiveProps(nextProps) {
    //     const profile = nextProps.profile
    //     const history = nextProps.history
    //     if (profile.profile_loaded){
    //         // history.goBack()
    //         switch(profile.profile.role) {
    //             case "ADMIN":
    //                 history.push('/users')
    //                 break;
    //             case "BRANCH_MANAGER":
    //                 history.push('/routes')
    //                 break;
    //             case "SALESMAN":
    //                 if (profile.profile.current_route_id && profile.profile.current_branch) {
    //                     history.push('/routes')
    //                 }
    //                 break;
    //             default:
    //                 break;
    //         }
    //     }
    // }


    render() {
        const { profile } = this.props;
        const subText = profile.profile.current_branch === null ? "กรุณาเลือกสาขาดำเนินการ" : "กรุณาเลือกเมนู"
        const displayContent = profile.profile_loaded ? 
            <div className="center-container">
                {/* <SmileOutlined style={{fontSize: 40, color: 'rgba(0, 0, 0, 0.45)'}}/> */}
                <Text type="secondary" style={{fontSize: 20}}>{subText}</Text>
                {/* <Text type="secondary" style={{fontSize: 20}}>ไม่พบหน้าที่ค้นหา</Text> */}
                {profile.profile.role === "SALESMAN" && !profile.profile.current_route_id && <Text type="secondary" style={{fontSize: 14}}>กรุณาติดต่อแอดมินเพื่อเลือกสายบริการ</Text>}
            </div> : <div className="center-container"></div>
        return displayContent
    }
}

function mapStateToProps(state) {
    return {
      profile: state.profile,
    };
}

export default withRouter((connect(mapStateToProps)(PageNotFound)));
